import {applyMiddleware, createStore} from "redux";
import {composeWithDevTools} from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";

import saga from "../saga/rootSaga";
import rootReducers from "./rootReducer";

const configureStore = () => {
  const sagaMidlleware = createSagaMiddleware();
  const store = createStore(
    rootReducers,
    composeWithDevTools(applyMiddleware(sagaMidlleware))
  );
  return {
    ...store,
    runSaga: sagaMidlleware.run(saga),
  };
};

const store = configureStore();

export default store;
